export default __webpack_public_path__ + "static/media/qhse-logo.22c671a0.png";